export default function (t) {
  return [
    { title: t('general.height'), field: 'height' },
    { title: t('general.weight'), field: 'weight' },
    { title: t('general.headDiameter'), field: 'headDiameter' },
    { title: t('general.waistCircumference'), field: 'waistCircumference' },
  ];
}
